(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["schoolsmart-product-zoom"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = (box) => {
    if (box.dataset.ssZoomReady === 'true') return;
    box.dataset.ssZoomReady = 'true';
    const image = box.querySelector('.ss-product-zoom__image');
    if (!image) return;
    let holdTimer;
    let touchZooming = false;

    const point = (clientX, clientY) => {
      const r = box.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      const y = Math.max(0, Math.min(100, ((clientY - r.top) / r.height) * 100));
      image.style.transformOrigin = `${x}% ${y}%`;
    };

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      box.addEventListener('mouseenter', () => box.classList.add('is-zooming'));
      box.addEventListener('mousemove', (e) => point(e.clientX, e.clientY));
      box.addEventListener('mouseleave', () => {
        box.classList.remove('is-zooming');
        image.style.transformOrigin = '50% 50%';
      });
    }

    box.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      const t = e.touches[0];
      holdTimer = window.setTimeout(() => {
        touchZooming = true;
        box.classList.add('is-zooming');
        point(t.clientX, t.clientY);
      }, 350);
    }, { passive: true });

    box.addEventListener('touchmove', (e) => {
      if (!touchZooming || e.touches.length !== 1) return;
      e.preventDefault();
      const t = e.touches[0];
      point(t.clientX, t.clientY);
    }, { passive: false });

    const stop = () => {
      window.clearTimeout(holdTimer);
      if (touchZooming) {
        touchZooming = false;
        box.classList.remove('is-zooming');
        image.style.transformOrigin = '50% 50%';
      }
    };
    box.addEventListener('touchend', stop, { passive: true });
    box.addEventListener('touchcancel', stop, { passive: true });
  };

  const init = () => document.querySelectorAll('[data-ss-product-zoom]').forEach(setup);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
  } catch(e) { console.error(e); }
})();

})();
